module.exports = require("core-js/library/fn/symbol");


/*****************
 ** WEBPACK FOOTER
 ** ./~/@babel/runtime-corejs2/core-js/symbol.js
 ** module id = 652
 ** module chunks = 0
 **/